import { Component, OnDestroy, OnInit, Input, ViewChild } from '@angular/core';
import { trackByName } from '@shared/common/track-by.util';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { DropdownPopComponent } from '../dropdown-pop/dropdown-pop.component';

@Component({
  standalone: false,
  selector: 'app-downloadfile',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss']
})
export class DownloadFileComponent implements OnInit, OnDestroy  {
    readonly trackByName = trackByName;
    @ViewChild('appdownloadpopModels', { static: true }) appdownloadpopModels: DropdownPopComponent;
    @ViewChild('downloadItpApps', { static: true }) downloadItpModal: ModalDirective;
    @Input() iconOnly = false;
    @Input() isDropup = false;
    @Input() togglerCssClass = 'btn btn-icon w-auto btn-clean d-flex align-items-center btn-md px-2';
    @Input() textCssClass = 'text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3';
    @Input() symbolCssClass = 'symbol symbol-35 symbol-light-success';
    @Input() symbolTextCssClass = 'symbol-label font-size-h5 font-weight-bold';
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1';
    active = false;
    saving = false;
    showModal: boolean;
    isLoginForFirstTime: boolean = false;
    checkLogin: string;
    carddata = [{ id: '1', name: 'In Time PRO for Windows', img: '../../../assets/common/images/login/NewWindowsDownloadIcon.png', imgIcon: '../../../assets/common/images/Download Icon.svg' },
        { id: '2', name: 'In Time PRO for Mac', img: '../../../assets/common/images/login/NewMacDownloadIcon.png', imgIcon: '../../../assets/common/images/Download Icon.svg' },
    ];

    URIDownload: string;
    private readonly downloadITPModalShowHandler = () => this.downloadITPModalShow();
    private readonly checkLoginForTopbarDownloadHandler = () => this.userQuickStartDetailsCheck();

    constructor(private userServiceProxy: UserServiceProxy) { }

    ngOnInit(): void {
        abp.event.on("DownloadITPModalShow", this.downloadITPModalShowHandler);
        abp.event.on('checkLoginForTopbardownload', this.checkLoginForTopbarDownloadHandler);
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    ngOnDestroy(): void {
        abp.event.off("DownloadITPModalShow", this.downloadITPModalShowHandler);
        abp.event.off('checkLoginForTopbardownload', this.checkLoginForTopbarDownloadHandler);
    }
   
    checkEvent(e:any) {
     
            localStorage.setItem('FirstTimeCheck', 'true');
            abp.event.trigger('CheckFirstLoginofUser');

    }

    userQuickStartDetailsCheck() {
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    downloadAgentAppWindows(item) {
        
        if (item.id === '1') {
            window.open("https://intimeproprodstorage.blob.core.windows.net/flutteragent/Windows/intimepro-2.0.0.05-windows-setup.exe", '_self');
        } else if (item.id === '2') {
            window.open("https://intimeproprodstorage.blob.core.windows.net/electron/DownloadMico/intimepro.zip", '_self');
        } else if (item.id === '3') {
            window.open("https://intimeprosstorage.file.core.windows.net/itpmacapppackage/ITP_Mac.pkg?st=2021-11-25T10:00:02Z&se=2023-01-01T10:00:00Z&sp=rcwdl&sv=2018-03-28&sr=f&sig=hDWxnhxWj%2fJlS989Lj8FnnYX6B6ay5YQyGSQYUMDDX4%3D", '_self');
        } else if (item.id === '4') {
            window.open("https://intimeprosstorage.file.core.windows.net/itpmacapppackage/ITP_Mac.pkg?st=2021-11-25T10:00:02Z&se=2023-01-01T10:00:00Z&sp=rcwdl&sv=2018-03-28&sr=f&sig=hDWxnhxWj%2fJlS989Lj8FnnYX6B6ay5YQyGSQYUMDDX4%3D", '_self');
        }
    }
    downloadITPModalShow() {
        this.downloadItpModal.show();
    }
    onDownloadModalHide(): void {
        localStorage.removeItem('isDownloadModalVisible');
        abp.event.trigger('DownloadITPModalHide');
    }
    remindMeLater(flag) {
        this.userServiceProxy.setRemindMeLaterForAgentApp(flag).subscribe(r => {});
        localStorage.setItem('firstTimeLoggedIn', 'false');
       
    }
}
